<template lang="">
  <div>
    <v-dialog v-model="popup" max-width="80%" transition="dialog-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="popup = true"v-bind="attrs" v-on="on" fab color="blue" dark><v-icon large >mdi-information-variant</v-icon></v-btn>
      </template>
      
      <v-card class="text-center">

        <!-- TOOLBAR -->
        <v-toolbar color="primary" dark> <v-card-title class="text-h5">
            Más Información
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn text fab @click="popup = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <!-- DATOS DE VARIABLES -->
        <v-card-text :style="'font-size:120%'" class="mt-6">
          <div v-if="datos_popup.length > 0">
            <v-row class="mt-4 ml-1">
              <v-icon class="mr-1" color='success'>mdi-circle</v-icon>En servicio
              <v-icon class="ml-5 mr-1" color='grey'>mdi-circle</v-icon>Parado
              <v-icon class="ml-5 mr-1" color='red'>mdi-circle</v-icon>Error
            </v-row>
            <v-row>
              <v-col>
                <v-list dense>
                  <v-list-item v-for="(item, index) in listaDatos1" :key="index"
                    :class="index % 2 == 0?'elemento_lista':null">
                    <v-list-item-content>
                      <v-col class="pa-0" cols="10">
                        {{item.name}}
                      </v-col>
                      <v-col class="pa-0" cols="2">
                        <v-icon v-if="item.value == 1 || item.value == 0 || item.value == 2"
                          :color="item.value==1?'success':item.value==0?'grey':'red'">mdi-circle</v-icon>
                        <span v-else>{{item.value}}</span>
                      </v-col>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>

              <v-divider vertical></v-divider>

              <v-col>
                <v-list dense>
                  <v-list-item v-for="(item, index) in listaDatos2" :key="index"
                    :class="index % 2 == 0?'elemento_lista':null">
                    <v-list-item-content>
                      <v-col class="pa-0" cols="10">
                        {{item.name}}
                      </v-col>
                      <v-col class="pa-0" cols="2">
                        <v-icon v-if="item.value == 1 || item.value == 0 || item.value == 2"
                          :color="item.value==1?'success':item.value==0?'grey':'red'">mdi-circle</v-icon>
                        <span v-else>{{item.value}}</span>
                      </v-col>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>

            <!-- DATOS DE QUEMADORES -->
            <v-row>

              <v-list width="100%">
                <!-- <v-list-group
                    :value="true"
                    no-action
                    >
                    <template v-slot:activator>
                      <v-list-item-title class="titulo_desplegable">QUEMADORES</v-list-item-title>
                    </template> -->

                <v-list-group class="quemadores" v-for="(zona_item, index) in titulos_quemadores" :key="index" :value="false"
                  no-action sub-group>
                  <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="titulo_desplegable">{{zona_item.name}} </v-list-item-title>
                    <v-list-item-subtitle class="titulo_desplegable" :style="`color:${zona_item.value==1?'green':zona_item.value==0?'grey':'red'};`">{{zona_item.value==1?'En servicio':zona_item.value==0?'Parado':'Error'}}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>

                  <v-list-item v-for="(item, i) in dynamicArray(zona_item.zona)" :class="i % 2 == 0?'elemento_lista':null"
                    :key="i">
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-title class="align-end">
                      <v-icon v-if="item.value == 1 || item.value == 0 || item.value == 2"
                        :color="item.value==1?'success':item.value==0?'grey':'red'">mdi-circle</v-icon>
                      <span v-else>{{item.value}}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list-group>
                <!-- </v-list-group> -->
              </v-list>
            </v-row>
          </div>
          <div v-else>
            (No hay datos del PLC)
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      popup: false,


    };
  },
  computed: {
    ...mapState(['datos_popup', 'alarmas_activas', 'alarmas']),
    listaDatos1() {
      return this.datos.slice(0, Math.ceil(this.datos.length / 2));
    },
    listaDatos2() {
      return this.datos.slice(Math.ceil(this.datos.length / 2));
    },
    datos() {
      if (this.datos_popup.length > 0) {
        // falta ver como se envian los datos de nodered
        return this.datos_popup.filter(e => !e.name.includes('QUEMADOR'))
      } else return []
      // let array_datos = [
      //   {name:"BOMBAS AGUA DEL FOSO", value:1},
      //   {name:"FLUJOSTATO DE AGUA", value:0},

      //   {name:"EN PREBARRIDO", value:0},
      //   {name:"FIN PREBARRIDO", value:1},

      //   {name:"FIN DE CARRERA PUERTA ARRIBA", value:1},
      //   {name:"FIN DE CARRERA PUERTA ABAJO", value:1},

      //   {name:"APRIETE PUERTA 1", value:1},
      //   {name:"APRIETE PUERTA 2", value:0},
      //   {name:"APRIETE PUERTA 3", value:0},
      //   {name:"APRIETE PUERTA 4", value:1},

      //   {name:"LIBERACIÓN PUERTA 1", value:1},
      //   {name:"LIBERACIÓN PUERTA 2", value:1},
      //   {name:"LIBERACIÓN PUERTA 3", value:1},
      //   {name:"LIBERACIÓN PUERTA 4", value:1},

      //   {name:"LIBERACIÓN TODOS LOS CILINDROS DE PUERTA", value:0},
      //   {name:"APRIETE TODOS LOS CILINDROS DE PUERTA", value:1},

      //   {name:"SUBIR PUERTA", value:0},
      //   {name:"BAJAR PUERTA", value:1},
      //   {name:"APRIETE PUERTA", value:0},

      //   {name:"TRANSFER AUTOMÁTICO", value:0},

      //   {name:"CARRO EN POSICIÓN 0", value:0},
      //   {name:"CARRO EN POSICIÓN 3", value:1},
      //   {name:"CARRO EN POSICIÓN 6", value:0},

      //   {name:"CONDICIONES CUMPLIDAS", value:1},
      //   {name:"ORDEN DE MARCHA", value:1},
      // ]
      // return array_datos
    },
    titulos_quemadores() {
      // let zonas = [
      //   {name:"ZONA 1", zona:1, value:1},
      //   {name:"ZONA 2", zona:2, value:0},
      // ]

      if (this.datos_popup.length > 0) {
        let zonas = JSON.parse(JSON.stringify(this.datos_popup.filter(e => e.name.includes('QUEMADORES'))));
        zonas.map(e => {
          e.name = e.name.replaceAll('_', ' ')
          e.zona = e.name.split(' ')[2]
          return e
        })
        return zonas
      }
      else return []
    },
    quemadores_zona1() {
      if (this.datos_popup.length > 0) {
        let quemadores = JSON.parse(JSON.stringify(this.datos_popup));
        quemadores = quemadores.filter(e => ['QUEMADOR_1', 'QUEMADOR_2', 'QUEMADOR_3', 'QUEMADOR_4', 'QUEMADOR_5'].includes(e.name))
        quemadores.map(e => { e.name = e.name.replace('_', ' '); return e })
        // if(this.alarmas.length > 0 && this.alarmas_activas.length > 0){
        //   quemadores.forEach(element => {
        //     let numero = element.name.split(' ')[1]
        //     console.log("EL NUMERO: ", numero);
        //     console.log(this.alarmas_activas);
        //     let alarma = this.alarmas_activas.find(e => { parseInt(e.id) == parseInt(numero)})
        //     if(alarma){
        //       console.log("SIIIIIIIIIIII");

        //       element.value = 2
        //     }
        //   });
        // }
        return quemadores
      } else return []
      // let zona1 = [
      //   {name:"Quemador 5", value:1},
      //   {name:"Quemador 7", value:1},
      //   {name:"Quemador 8", value:1},
      //   {name:"Quemador 9", value:1},
      //   {name:"Quemador 10", value:1},
      // ]
      // return zona1
    },
    quemadores_zona2() {
      if (this.datos_popup.length > 0) {
        let quemadores = JSON.parse(JSON.stringify(this.datos_popup));
        quemadores = quemadores.filter(e => ['QUEMADOR_6', 'QUEMADOR_7', 'QUEMADOR_8', 'QUEMADOR_9', 'QUEMADOR_10'].includes(e.name))
        quemadores.map(e => { e.name = e.name.replace('_', ' '); return e })
        // if(this.alarmas.length > 0 && this.alarmas_activas.length > 0){
        //   quemadores.forEach(element => {
        //     let numero = element.name.split(' ')[1]
        //     let alarma = this.alarmas_activas.find(e => { parseInt(e.id) == parseInt(numero)})
        //     if(alarma){
        //       element.value = 2
        //     }
        //   });
        // }
        return quemadores
      } else return []
      // let zona2 = [
      //   {name:"Quemador 1", value:0},
      //   {name:"Quemador 2", value:1},
      //   {name:"Quemador 3", value:1},
      //   {name:"Quemador 4", value:1},
      //   {name:"Quemador 6", value:0},
      // ]
      // return zona2
    },
    // posicion_carro(){
    //   let posiciones = [
    //     {name:"posicion_0", value:0},
    //     {name:"posicion_3", value:1},
    //     {name:"posicion_6", value:0},
    //   ]
    //   let posicion = posiciones.find(e => e.value == 1)
    //   if(posicion){
    //     return {name:"CARRO EN POSICION", value: posicion.name.split('_')[1]}
    //   }
    //   return {name:"CARRO EN POSICION", value: '0'}
    // }

  },

  methods: {
    dynamicArray(zona) {
      // Generate your dynamic array based on conditions
      return this[`quemadores_zona${zona}`] || [];
    },
  },

}
</script>
<style>
.titulo_desplegable {
  text-align: center;
}

.elemento_lista {
  /* border-bottom: 1px solid #ccc;   */
  background-color: rgba(234, 234, 234, 0.926);
}

.quemadores {
  border-top: 1px solid #ccc;
}
</style>